import React, { useEffect, useState } from "react";
import { Form, Button, Select, Space, Card, message, Switch } from "antd";
import PropTypes from "prop-types";
import apiClient from "../../../utils/apiClient"; // Assuming apiClient is already configured
import useToast from "../../../hooks/userToast";
import { DeleteOutline } from "@mui/icons-material";

ManageStudyPreference.propTypes = {
  studyId: PropTypes.number.isRequired,
  handleOk: PropTypes.func,
  fetchData: PropTypes.func,
  isEmergency: PropTypes.bool,
  studyStatus: PropTypes.string,
};

const { Option } = Select;

function ManageStudyPreference({
  studyId,
  handleOk,
  fetchData,
  isEmergency,
  studyStatus,
}) {

  const [form] = Form.useForm();
  const [radiologists, setRadiologists] = useState([]);
  const [priorities, setPriorities] = useState([]);
  const [radiologistDetails, setRadiologistDetails] = useState([]);
  const [deleted, isDeleted] = useState(false);
  const [radilologistId, setRadiologistId] = useState("");
  const [currentDetail, setCurrentDetail] = useState({
    radiologist: "",
    priority: "",
    category: 3,
  });
  const [isEmergencyState, setIsEmergencyState] = useState(isEmergency);
  console.log(studyStatus, "study status in manage study preference");

  const { toastError, toastSuccess } = useToast();

  useEffect(() => {
    const defaultRadiologistPriority = localStorage.getItem("defaultRadiologistPriority");
    if (defaultRadiologistPriority && radiologists.length > 0) {
      setRadiologistDetails(JSON.parse(defaultRadiologistPriority));
      form.setFieldsValue({
        radiologistPrefrence: JSON.parse(defaultRadiologistPriority),
      });
    }
  }, [radiologists]);
  const fetchRadiologists = async () => {
    try {
      const response = await apiClient.get(
        `/users?role=radiologist&categoryId=5&limit=1000`
      );
      const data = response?.data?.users?.data;
      setRadiologists(data);
    } catch (error) {
      console.error("Error fetching radiologists:", error);
      toastError("Error fetching radiologists");
    }
  };

  const fetchPriorities = async () => {
    try {
      const response = await apiClient.get(`/priority`);
      const data = response?.data?.priority?.data;
      setPriorities(data);
    } catch (error) {
      console.error("Error fetching priorities:", error);
      toastError("Error fetching priorities");
    }
  };

  const deleteRadiologist = async (id) => {
    try {
      const res = await apiClient.delete(
        `/studyInfo/preference/deleteStudyPreference/${id.studyId}`
      );
      if (res?.status === 200) {
        toastSuccess("Radiologist deleted successfully");
        fetchData();
        isDeleted(!deleted);
      }
    } catch (error) {
      toastError("Please try again later");
      console.log(error, "error in delete radiologist");
    }
  };

  const fetchExistingPreferences = async () => {
    try {
      const response = await apiClient.get(
        `/studyInfo/preference/getStudyPreference?studyInfoId=${studyId}`
      );
      const data = response?.data?.studyDetail?.rows;
      if (data) {
        const mappedPreferences = data.map((preference) => ({
          radilologistId: preference.radiologist.id,
          radiologistName: preference.radiologist.name,
          studyId: preference.id,
          priorityName: preference.priority.name,
          priority: preference.priority,
          category: preference.category.id,
        }));
        setRadiologistId(mappedPreferences);
      }
    } catch (error) {
      console.error("Error fetching existing preferences:", error);
      toastError("Error fetching existing preferences");
    }
  };

  useEffect(() => {
    fetchRadiologists();
    fetchPriorities();
    fetchExistingPreferences();
  }, [studyId, deleted]);

  const handleAddRow = () => {
    setRadiologistDetails([...radiologistDetails, { ...currentDetail }]);

    if (currentDetail?.radiologist && currentDetail?.priority) {
      setRadiologistDetails([...radiologistDetails, { category: 3 }]);

      setCurrentDetail({ radiologist: "", priority: "" });
    } else {
      message.warning("Please select radiologist and priority");
    }
  };

  const handleDeleteRow = (index) => {
    setRadiologistDetails(radiologistDetails.filter((_, idx) => idx !== index));
  };

  const handleSubmit = async () => {
    const payload = {
      radiologistPrefrence: radiologistDetails,
      studyId,
    };

    localStorage.setItem("defaultRadiologistPriority", JSON.stringify(radiologistDetails));

    try {
      await apiClient.post(
        `/studyInfo/preference/createStudyPreference`,
        payload
      );
      toastSuccess("Preferences updated successfully");

      if (handleOk) handleOk();
      if (fetchData) fetchData();
    } catch (error) {
      toastError("Failed to update preferences", error);
    }
  };

  // Function to handle the toggle change
  const handleEmergencyToggle = async (checked) => {
    const res = await apiClient.patch(
      `/studyInfo/emergencyFlagUpdate/${studyId}`,
      {
        emergency_flag: checked ? 1 : 0,
      }
    );
    console.log(res, "emergency flag response", {
      emergency_flag: checked,
    });
    if (res?.status === 200) {
      toastSuccess("Emergency mode updated successfully");
      fetchData();
      setIsEmergencyState(checked);
    } else {
      toastError("Failed to update emergency mode");
    }

    // You can also pass this state to the parent component via a callback if necessary
    console.log("Emergency mode is now:", checked ? "ON" : "OFF");
  };

  return (
    <Card title={`Manage Preferences for Study #${studyId}`}>
      {/* Emergency Toggle Button */}
      {studyStatus == "unread" && (
        <div className="emergency-toggle">
          <label className="mx-2 py-2">Emergency Study: </label>
          <Switch
            checked={isEmergencyState}
            onChange={handleEmergencyToggle}
            checkedChildren="Emergency"
            unCheckedChildren="Normal"
            className=""
          />
        </div>
      )}

      <Form form={form} onFinish={handleSubmit} layout="vertical">
        <Form.List name="radiologistPrefrence">
          {() => (
            <>
              {radilologistId?.length > 0 && (
                <ul className="list-group list-group-flush mb-3">
                  {radilologistId.map((item, index) => (
                    <li className="list-group-item" key={index}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>{item.radiologistName}</span>
                        <span>{item.priorityName}</span>
                        <DeleteOutline
                          style={{ cursor: "pointer" }}
                          onClick={() => deleteRadiologist(item)}
                        />
                      </div>
                    </li>
                  ))}
                </ul>
              )}

              {radiologistDetails?.length > 0 && (
                <>
                  {radiologistDetails.map((_, index) => (
                    <Space
                      key={index}
                      align="baseline"
                      style={{ marginBottom: 8 }}
                    >
                      <Form.Item
                        name={[index, "radiologist"]}
                        rules={[
                          { required: true, message: "Radiologist required" },
                        ]}
                      >
                        <Select
                          placeholder="Select Radiologist"
                          style={{ width: 200 }}
                          value={radiologistDetails[index]?.radiologist}
                          onChange={(value) => {
                            const updatedDetails = [...radiologistDetails];
                            updatedDetails[index].radiologist = value;
                            setRadiologistDetails(updatedDetails);
                          }}
                          showSearch
                          allowClear
                          optionFilterProp="children"
                        >
                          {radiologists.map((radiologist) => (
                            <Option key={radiologist.id} value={radiologist.id}>
                              {radiologist.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      <Form.Item
                        name={[index, "priority"]}
                        rules={[
                          { required: true, message: "Priority required" },
                        ]}
                      >
                        <Select
                          placeholder="Select Priority"
                          style={{ width: 120 }}
                          value={radiologistDetails[index]?.priority}
                          onChange={(value) => {
                            const updatedDetails = [...radiologistDetails];
                            updatedDetails[index].priority = value;
                            setRadiologistDetails(updatedDetails);
                          }}
                        >
                          {priorities.map((priority) => (
                            <Option key={priority.id} value={priority.id}>
                              {priority.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      <Button danger onClick={() => handleDeleteRow(index)}>
                        Remove
                      </Button>
                    </Space>
                  ))}
                </>
              )}

              <Form.Item>
                <Button
                  type="dashed"
                  onClick={handleAddRow}
                  block
                  disabled={studyStatus !== "unread"}
                >
                  + Add Radiologist Preference
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>

        <div className="d-flex justify-content-center">
          <Button
            type="primary"
            htmlType="submit"
            disabled={studyStatus !== "unread"}
          >
            Submit Preferences
          </Button>
        </div>
      </Form>
    </Card>
  );
}

export default ManageStudyPreference;
